import { getInitialState, getPath } from "../../utils";

const initialState = {
  tdsCertificates: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_TDS_CERTIFICATES": {
      return setTdsCertificates(state, action);
    }
    default: {
      return state;
    }
  }
}

const setTdsCertificates = (state, action) => {
  return {
    ...state,
    tdsCertificates: getPath(action.payload, "tds_certificates", []),
  };
};
